document.addEventListener('DOMContentLoaded', function() {
  $('.testimonials-slider').slick({
    dots: false,
    infinite: false,
    arrows: true,
    vertical: false,
    verticalSwiping: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          verticalSwiping: false,
        }
      }
    ]
  });

  $('.home_multicolumn .grid').slick({
    dots: true,
    infinite: false,
    arrows: true,
    speed: 1000,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        }
      }
    ]
  });

  // $('.home_multicolumn .grid').on('wheel', function(e) {
  //   e.preventDefault();

  //   if (e.originalEvent.deltaY < 0) {
  //     $(this).slick('slickNext');
  //   } else {
  //     $(this).slick('slickPrev');
  //   }
  // });
});



document.addEventListener('DOMContentLoaded', function() {
    let hamburgerButton = document.querySelector('.js-drawer-open-nav');
    let closeButton = document.querySelector('.custom-drawer-close .js-drawer-close');
    let trigerclose = document.querySelector('.trigger-close .js-drawer-close'); 
  hamburgerButton.addEventListener('click', () => {
      hamburgerButton.style.display = 'none';
      closeButton.style.display = 'block';
    });
    closeButton.addEventListener('click', () => {
      closeButton.style.display = 'none';
      hamburgerButton.style.display = 'block';
      trigerclose.click();
    });
  });